<template>
    <div class='MainSidebar'>
        <div class='title-logo'>
            <img :src='sysInfo.sysLogo' alt=''>
        </div>
        <div class='menu-item' :class="{'avtive': menuActive(subItem)}" v-for='(subItem,index) in menuList' :key='index' @click="onTab(subItem)" :style="index === menuList.length-1 ? 'margin-bottom: 40px':''">
            <i :class="subItem.menuIcon"></i>
            <span>{{ subItem.menuName }}</span>
        </div>
        <div class="copyright">
            <span>{{ sysInfo.sysVersion }}</span>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import bus from '@/components/common/bus';
export default {
    data (){
        return{
            menuIndex: 0,
            collapse: false,
        }
    },
    computed: {
        ...mapState(['menuList']),
        ...mapState(['sysInfo']),
        onRoutes() {
            return this.$route.path;
        }
    },
    created() {
        bus.$on('collapse-content', (msg) => {
            this.collapse = msg;
        });
    },
    mounted() {
        this.$nextTick(()=>{
            this.isIndex();
        })
    },
    watch:{
        onRoutes:{
          handler(newValue,oldValue){
              console.log('newValue,oldValue',newValue,oldValue)
              this.isIndex();
          },
        },
        menuList(newValue,oldValue){
            console.log('newValue,oldValue',newValue,oldValue)
        }
    },
    methods:{
        // 更具URL匹配主菜单及向子菜单传输数据
        menuActive(subItem){
            for (const item of subItem.children) {
                if(item.menuLink === this.onRoutes){
                    bus.$emit('ChildMenu',subItem)
                    return true
                }
            }
            return false
        },

        // 点击主菜单向子菜单传数据
        onTab(subItem){
            bus.$emit('ChildMenu',subItem)
            bus.$emit('open-btn')

            this.$router.push(subItem.children[0].menuLink);
        },

        // 判断当前是否是首页菜单并折叠子菜单
        isIndex(){
            setTimeout(()=>{
                if(this.onRoutes === this.menuList[0].children[0].menuLink){
                    bus.$emit('close-btn')
                }
            },800)
        }
    }
}
</script>

<style scoped>
.MainSidebar{
    position: absolute;
    top: 0;
    left: 0;
    width: 100px;
    height: 100%;
    color: #ffffff;
    font-size: 14px;
    border-right: #e4eaec 1px solid;
    background-color: #1c2233;
    overflow-y: scroll;
    z-index: 2;
}
.MainSidebar::-webkit-scrollbar {
    display: none;
}
.MainSidebar .avtive{
    color: #333;
    background-color: #ecf5ff;
}
.title-logo{
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
        width: 70px;
        height: 35px;
    }
}
.menu-item{
    width: 100%;
    height: 40px;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.menu-item:hover{
    color: #333;
    background-color: #ecf5ff;
}
.menu-item i{
    margin-right: 10px;
}
.copyright{
    width: 99px;
    height: 40px;
    position: fixed;
    bottom: 0;
    background-color: #1c2233;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}

@media screen and (max-width: 1000px){
    .MainSidebar{
        width: 0;
        overflow: hidden;
    }

    .copyright{
        left: -100px;
    }
}
</style>